import React, { useRef, useState } from "react";
import { Dialog } from "@headlessui/react";
import Input from "../controls/Input";
import {
  ArrowRightCircleIcon,
  BackspaceIcon,
} from "@heroicons/react/24/outline";

const PAD_KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

const padButtonClass =
  "rounded-md bg-indigo-600 px-3 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600";

export default function NextInProcessModal(props) {
  const { buttonMessage, confirmAction, message, setOpen, title } = props;
  const cancelButtonRef = useRef(null);
  const [employeePin, setEmployeePin] = useState("");

  const appendDigit = (digit) => {
    setEmployeePin((prev) => `${prev}${digit}`);
  };

  const backspace = () => {
    setEmployeePin((prev) => prev.slice(0, -1));
  };

  return (
    <div>
      <div>
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-indigo-100">
          <ArrowRightCircleIcon
            className="h-11 w-11 text-indigo-600"
            aria-hidden="true"
          />
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-base font-normal leading-6 text-gray-800 family-didact"
          >
            {title}
          </Dialog.Title>
          <div className="mt-2">
            <p className="text-sm font-normal family-didact">{message}</p>
          </div>
        </div>

        <div className="mt-4 flex flex-col items-center">
          <div className="w-full max-w-xs">
            <label
              htmlFor="pin"
              className="mb-1 block text-center text-sm font-medium text-[#0F172A]"
            >
              User Pin
            </label>
            <Input
              name="pin"
              onChange={(e) => setEmployeePin(e.target.value)}
              value={employeePin}
              labelOn={false}
              type="password"
              inputMode="numeric"
              pattern="\d*"
              autoComplete="off"
              className="block w-full rounded-md border border-gray-300 px-3 py-35-custom text-center shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div className="mt-4 w-full max-w-xs grid grid-cols-3 gap-2">
            {PAD_KEYS.slice(0, 9).map((digit) => (
              <button
                key={digit}
                type="button"
                className={padButtonClass}
                onClick={() => appendDigit(digit)}
              >
                {digit}
              </button>
            ))}
            <div aria-hidden="true" />
            <button
              type="button"
              className={padButtonClass}
              onClick={() => appendDigit("0")}
            >
              0
            </button>
            <button
              type="button"
              className="rounded-md bg-gray-600 px-3 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
              onClick={backspace}
              aria-label="Delete last digit"
            >
              <BackspaceIcon className="mx-auto h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 flex items-center justify-center sm:grid sm:grid-flow-row-dense sm:grid-cols-2 gap-3">
        <div className="col-span-1 text-right">
          <button
            type="button"
            className="inline-flex w-fit justify-center rounded-md bg-white px-3 py-2 text-sm font-light family-didact text-gray-900 shadow-sm hover:bg-gray-50 shadow-sm ring-1 ring-inset ring-gray-300"
            onClick={() => setOpen({ childComponent: null, open: false })}
          >
            Cancel
          </button>
        </div>
        <div className="col-span-1">
          <button
            type="button"
            className="inline-flex w-fit justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-light family-didact text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 col-span-1 sm:mt-0"
            onClick={() => confirmAction(employeePin)}
            ref={cancelButtonRef}
          >
            {buttonMessage}
          </button>
        </div>
      </div>
    </div>
  );
}
